import { createSlice } from '@reduxjs/toolkit';

export type Tag = {
  id: number;
  name: string;
  color: string;
};

type InitialState = {
  tags: Tag[] | null;
  selectedTags: number[];
};

const initialState: InitialState = {
  tags: null,
  selectedTags: [],
};

const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    setTags: (state, { payload }) => {
      state.tags = payload;
    },
    setSelectedTags: (state, { payload }: { payload: { id: number } }) => {
      const data = state.selectedTags.includes(payload.id)
        ? state.selectedTags.filter(tagId => tagId !== payload.id)
        : [...state.selectedTags, payload.id];

      state.selectedTags = data;
    },
  },
});

export const { setTags, setSelectedTags } = tagsSlice.actions;

export default tagsSlice.reducer;
